import { useCallback } from 'react';
import { prop } from 'ramda';
import { useTranslations } from 'js/hooks/i18n';
import { useGetErrorResponseMessage } from 'js/hooks/server';
import { useShowNotification } from 'js/hooks/useShowNotification';
import { usePortletConfig, usePortletSelector } from 'js/components/system/Portlet';
import { acceptLimits, declineLimits } from 'js/components/main/ResponsibleGaming/server';

const useConfirmPlayerLimits = ({ action, limitType, timePeriod, setIsLoading, setConfirmError, message }) => {
    const showNotification = useShowNotification();
    const { portletType: type } = usePortletConfig();
    const getErrorResponseMessage = useGetErrorResponseMessage();
    const fetchPortlet = usePortletSelector(prop('fetchPortlet'));
    const translate = useTranslations('playtech.mobile.system.responsibleGaming.limits.');

    return useCallback(async () => {
        setIsLoading(true);
        setConfirmError('');

        try {
            await action({ limitType, timePeriods: [timePeriod] });

            showNotification(translate(message), { variant: 'success' });
            fetchPortlet({ type }, { showLoader: false });
        } catch (error) {
            const errorMessage = getErrorResponseMessage(error);

            setConfirmError(errorMessage);
        } finally {
            setIsLoading(false);
        }
    }, [
        action, timePeriod, setIsLoading, setConfirmError, message,
        type, limitType, getErrorResponseMessage, fetchPortlet, translate, showNotification
    ]);
};

export const useAcceptPlayerLimits = ({ timePeriod, limitType, setIsLoading, setConfirmError }) => {
    const action = useConfirmPlayerLimits({
        limitType,
        timePeriod,
        setIsLoading,
        setConfirmError,
        action: acceptLimits,
        message: 'acceptSuccess'
    });

    return useCallback(async () => {
        await action();
    }, [action]);
};

export const useDeclinePlayerLimits = ({ timePeriod, limitType, setIsLoading, setConfirmError }) => {
    const action = useConfirmPlayerLimits({
        limitType,
        timePeriod,
        setIsLoading,
        setConfirmError,
        action: declineLimits,
        message: 'declineSuccess'
    });

    return useCallback(async () => {
        await action();
    }, [action]);
};
